// Types
import type { HeaderListType } from "../../../types"

export const headerList: HeaderListType[] = [
  {
    label: "Customer Name",
    value: "Customer_name",
    required: true
  },
  {
    label: "Customer Code",
    value: "Customer_code",
    required: false
  }
]